import {
	BrandPrimaryColor,
	getHomeURL,
	getStoreName,
	RelyingParty,
	relyingPartyDefaults,
} from '@pcid/utils/relying-party-utils';

const config = ({ language }) => ({
	...relyingPartyDefaults,
	storeName: getStoreName(RelyingParty.PCO_WEB),
	homeURL: getHomeURL(RelyingParty.PCO_WEB),
	termsURL: `https://www.pcoptimum.ca/company-policy/terms-and-conditions?locale=${language}-ca`,
	symbol: `pco-${language}`,
	color: BrandPrimaryColor.PINK,
});
export default config;
